// Add class to current page link 

$(function(){
  $('a').each(function() {
    if ($(this).prop('href') == window.location.href) {
      $(this).addClass('current');
    }
  });
});

// Toggle More Services We Offer

$(document).ready(function(){
  $(".btn.btn--secondary.btn--small.btn--tint-border").click(function(){
    $("#shopify-section-template--16700873081073__16631930301206b1bf, #shopify-section-template--16700873081073__165816847640b00cfd, #shopify-section-template--16700873081073__166319553753560829").slideToggle(500);
  });
});


if (/trail-gear/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';
}

if (/trail-gear/.test(window.location.href)) {
url.slice(0, url.lastIndexOf('/'));
}


if (/rotopax/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}

if (/storage/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}

if (/powertank/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}

if (/recovery/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}

if (/comms/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}

if (/camping/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}

if (/electrical/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}

if (/batteries/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}

if (/lighting/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}

if (/switches/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}

if (/safety/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}

if (/first-aid-kits/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}

if (/fire-extinguishers/.test(window.location.href)) {
document.getElementById('shopify-block-5a1ab783-4e7b-40d0-ae90-24e55f42ded7').style.display = 'none';}



